import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { collections } from '@/mocks/content';

export default function Collections() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section id="collections" className="py-12 md:py-16 scroll-mt-20 bg-background-100/70">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="无删减合集"
          title="无删减合集整理：长篇内容按主题一次看够"
          desc="把长篇的纪录片、混剪、连麦回放与手作教程按主题打包，每条都注明收录数量与更新节奏。点开卡片下方的按钮，就能看到合集内的具体条目。"
        />

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {collections.map((item) => {
            const open = openId === item.id;
            return (
              <article
                key={item.id}
                className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1 dv-reveal"
              >
                <div className="relative w-full h-[240px] md:h-[280px]">
                  <img
                    src={item.cover}
                    alt={`${item.title} 合集封面`}
                    title={`${item.title} 无删减合集`}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/15 to-transparent" />
                  <span className="absolute top-3 left-3 rounded bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-foreground-950">
                    {item.badge}
                  </span>
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="font-heading text-base font-bold text-white">{item.title}</h3>
                    <p className="mt-1 text-[11px] text-white/80">{item.count}</p>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-4">
                  <p className="text-xs md:text-sm leading-relaxed text-foreground-600">{item.desc}</p>

                  {open ? (
                    <ul className="mt-3 space-y-2 border-t border-background-200 pt-3">
                      {item.samples.map((sample) => (
                        <li key={sample} className="flex items-start gap-2 text-xs text-foreground-700">
                          <i className="ri-play-circle-line mt-0.5 text-primary-600" />
                          <span>{sample}</span>
                        </li>
                      ))}
                    </ul>
                  ) : null}

                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-expanded={open}
                    className="mt-4 inline-flex w-full items-center justify-center gap-1.5 rounded-md border border-secondary-300 bg-secondary-50 px-3 py-2 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-100 cursor-pointer whitespace-nowrap"
                  >
                    {open ? '收起合集内容' : '查看合集内容'}
                    <i className={open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} />
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}